<template>
  <model-form
    ref="modelForm"
    :model="report"
    modal-type="modal"
    width="800px"
    :close-on-save="false"
    :before-save="clearAction"
    @change="$emit('change')"
  >
    <div
      class="column"
    >
      <div class="text-bold q-mb-md">
        PDF Settings
      </div>

      <div class="row q-gutter-md q-mb-md items-start">
        <q-checkbox
          v-model="report.pdfLandscape"
          class="col"
          label="Render PDF Landscape"
          bottom-slots
        />
        <q-input
          v-model.number="report.pdfWidth"
          type="number"
          class="col"
          label="PDF Width (px)"
          min="500"
          max="5000"
          :rules="[
            val => !!val || 'Field is required',
            val => val >= 500 || 'Cannot be less than 500',
            val => val <= 5000 || 'Cannot be greater than 5000'
          ]"
          bottom-slots
        />
        <q-checkbox
          v-model="report.pdfMargins"
          class="col"
          label="Include PDF Margins"
          bottom-slots
        />
        <q-checkbox
          v-model="report.pdfHeader"
          class="col"
          label="Include PDF Header"
          bottom-slots
        />
      </div>
    </div>
    <div
      v-if="report.isRemote"
      class="column"
    >
      <div class="text-bold q-mb-md">
        Email Settings
      </div>

      <div class="row q-col-gutter-md items-start">
        <q-input
          v-model.number="report.mobileEmailWidth"
          type="number"
          class="col-4"
          label="Mobile Email Width (px)"
          min="200"
          max="1500"
          :rules="[
            val => val !== '' || 'Field is required',
            val => val <= 1500 || 'Cannot be more than 1500',
            val => val >= 500 || 'Cannot be less than 500'
          ]"
          bottom-slots
        />
        <q-input
          v-model.number="report.mobileEmailScale"
          type="number"
          class="col-4"
          label="Mobile Email Scale (%)"
          min="50"
          max="500"
          :rules="[
            val => val !== '' || 'Field is required',
            val => val <= 500 || 'Cannot be more than 500',
            val => val >= 50 || 'Cannot be less than 50'
          ]"
          bottom-slots
        />
        <q-input
          v-model.number="report.maxEmailImageHeight"
          type="number"
          class="col-4"
          label="Max Email Image Height (px)"
          min="1000"
          max="10000"
          :rules="[
            val => val !== '' || 'Field is required',
            val => val <= 30000 || 'Cannot be more than 30000',
            val => val >= 1000 || 'Cannot be less than 1000'
          ]"
          bottom-slots
        />
      </div>

      <div class="row q-col-gutter-md q-mb-md items-start">
        <q-input
          v-model.number="report.desktopEmailWidth"
          type="number"
          class="col-4"
          label="Desktop Email Width (px)"
          min="200"
          max="1500"
          :rules="[
            val => val !== '' || 'Field is required',
            val => val <= 1500 || 'Cannot be more than 1500',
            val => val >= 500 || 'Cannot be less than 500'
          ]"
          bottom-slots
        />
        <q-input
          v-model.number="report.desktopEmailScale"
          type="number"
          class="col-4"
          label="Desktop Email Scale (%)"
          min="50"
          max="500"
          :rules="[
            val => val !== '' || 'Field is required',
            val => val <= 500 || 'Cannot be more than 500',
            val => val >= 50 || 'Cannot be less than 50'
          ]"
          bottom-slots
        />
      </div>
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'ReportPrintSettingsDialog',
  components: {
    ModelForm
  },
  emits: ['change'],
  data () {
    return {
    }
  },
  context: ['currentUser'],
  models: {
    report: 'default'
  },
  methods: {
    show (model, initial) {
      this.$refs.modelForm.show(model, initial)
    },
    clearAction () {
      this.report.resetField('action')
    }
  }
}

</script>
